import React from 'react'
import BaseIcon from 'react-icon-base'

const RightArrowWithDots = props => (
  <BaseIcon width="36" height="14" viewBox="0 0 36 14" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(.07 .028)" fill="#B0C0C6" fillRule="evenodd">
      <ellipse cx="1.75" cy="6.437" rx="1.75" ry="1.652" />
      <ellipse cx="8.75" cy="6.437" rx="1.75" ry="1.652" />
      <ellipse cx="16.25" cy="6.437" rx="1.75" ry="1.652" />
      <ellipse cx="23.25" cy="6.437" rx="1.75" ry="1.652" />
      <path fillRule="nonzero" d="M27.638 0 26.11 1.528l4.97 4.944-4.97 4.945 1.528 1.528 6.472-6.473z" />
    </g>
  </BaseIcon>
)

export default RightArrowWithDots
